<template>
    <div class="publish-history-container">
        <div class="page-header">
            <h2>我的发布记录</h2>
            <el-button type="primary" @click="goBack">返回</el-button>
        </div>

        <div class="publish-list">
            <div v-if="publishList.length === 0" class="empty-state">
                <div class="empty-icon">📝</div>
                <p>暂无发布记录</p>
                <el-button type="primary" @click="goPublish">立即发布</el-button>
            </div>

            <div v-else>
                <div class="publish-item" v-for="item in publishList" :key="item.id">
                    <div class="item-image">
                        <img :src="item.img || defaultImage" :alt="item.head" @error="handleImageError" />
                    </div>
                    <div class="item-content">
                        <div class="item-header">
                            <h3 class="item-title">{{ item.head }}</h3>
                            <div class="status-badge" :class="getStatusClass(item.status)">
                                {{ getStatusText(item.status) }}
                            </div>
                        </div>
                        <div class="item-info">
                            <p class="company-name">{{ item.zd3 }}</p>
                            <p class="item-desc">{{ item.desc }}</p>
                        </div>
                        <div class="item-meta">
                            <span class="contact-info">联系人：{{ item.zd1 }}</span>
                            <span class="contact-phone">电话：{{ item.zd2 }}</span>
                        </div>
                        <div class="item-footer">
                            <span class="publish-time">发布时间：{{ formatTime(item.createTime) }}</span>
                            <div class="item-actions">
                                <el-button size="mini" @click="viewDetail(item)">查看详情</el-button>
                                <!-- <el-button size="mini" type="primary" @click="editItem(item)" v-if="item.status === 'rejected'">重新编辑</el-button> -->
                                <!-- <el-button size="mini" type="danger" @click="deleteItem(item.id)">删除</el-button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 分页 -->
        <el-pagination
            v-if="total > 0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            class="pagination">
        </el-pagination>

        <!-- 详情弹框 -->
        <el-dialog title="发布详情" :visible.sync="detailVisible" width="600px">
            <div class="detail-content" v-if="currentItem">
                <div class="detail-row">
                    <label>标题：</label>
                    <span>{{ currentItem.head }}</span>
                </div>
                <div class="detail-row">
                    <label>公司名称：</label>
                    <span>{{ currentItem.zd3 }}</span>
                </div>
                <div class="detail-row">
                    <label>联系人：</label>
                    <span>{{ currentItem.zd1 }}</span>
                </div>
                <div class="detail-row">
                    <label>联系方式：</label>
                    <span>{{ currentItem.zd2 }}</span>
                </div>
                <div class="detail-row">
                    <label>简介：</label>
                    <span>{{ currentItem.desc }}</span>
                </div>
                <div class="detail-row">
                    <label>详细内容：</label>
                    <div class="detail-text">{{ currentItem.detail }}</div>
                </div>
                <div class="detail-row">
                    <label>审核状态：</label>
                    <span :class="getStatusClass(currentItem.status)">{{ getStatusText(currentItem.status) }}</span>
                </div>
                <div class="detail-row" v-if="currentItem.rejectReason">
                    <label>拒绝原因：</label>
                    <span class="reject-reason">{{ currentItem.rejectReason }}</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'PublishHistory',
    data() {
        return {
            publishList: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            loading: false,
            detailVisible: false,
            currentItem: null,
            defaultImage: require('@/assets/images/logo.png')
        }
    },
    created() {
        this.loadPublishList();
    },
    methods: {
        // 加载发布列表
        loadPublishList() {
            this.loading = true;
            // 模拟数据，实际项目中应该调用API
            setTimeout(() => {
                this.publishList = [
                    {
                        id: 1,
                        head: '专业网站建设服务',
                        desc: '提供企业网站、电商网站等专业建设服务',
                        img: 'https://oss.yueshiwl.com/img/1673942497876/1-1.png',
                        detail: '我们是一家专业的网站建设公司，拥有多年经验...',
                        zd1: '张先生',
                        zd2: '19357583560',
                        zd3: '杭州网络科技有限公司',
                        status: 'rejected', // pending, approved, rejected
                        createTime: '2025-01-15 10:30:00',
                        rejectReason: ''
                    },
                    {
                        id: 2,
                        head: '小程序开发定制',
                        desc: '专业小程序开发，包含商城、企业展示等类型',
                        img: 'https://oss.yueshiwl.com/img/1673942498065/1-2.png',
                        detail: '提供微信小程序、支付宝小程序开发服务...',
                        zd1: '李女士',
                        zd2: '19357583560',
                        zd3: '创新科技公司',
                        status: 'pending',
                        createTime: '2025-01-14 15:20:00',
                        rejectReason: ''
                    }
                ];
                this.total = this.publishList.length;
                this.loading = false;
            }, 1000);
        },

        // 获取状态样式类
        getStatusClass(status) {
            const statusMap = {
                'pending': 'status-pending',
                'approved': 'status-approved',
                'rejected': 'status-rejected'
            };
            return statusMap[status] || 'status-pending';
        },

        // 获取状态文本
        getStatusText(status) {
            const statusMap = {
                'pending': '审核中',
                'approved': '已通过',
                'rejected': '已拒绝'
            };
            return statusMap[status] || '未知状态';
        },

        // 格式化时间
        formatTime(timeStr) {
            if (!timeStr) return '';
            return timeStr;
        },

        // 处理图片加载错误
        handleImageError(e) {
            e.target.src = this.defaultImage;
        },

        // 查看详情
        viewDetail(item) {
            this.currentItem = item;
            this.detailVisible = true;
        },

        // 编辑项目
        editItem(item) {
            this.$message.info('编辑功能待实现');
        },

        // 删除项目
        deleteItem(id) {
            this.$confirm('确定要删除这条发布记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 实际项目中调用删除API
                this.publishList = this.publishList.filter(item => item.id !== id);
                this.total = this.publishList.length;
                this.$message.success('删除成功');
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val;
            this.loadPublishList();
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.loadPublishList();
        },

        // 返回
        goBack() {
            this.$router.go(-1);
        },

        // 去发布
        goPublish() {
            this.$router.push('/');
        }
    }
}
</script>

<style scoped>
.publish-history-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background-color: #f5f5f5;
    min-height: 100vh;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.page-header h2 {
    margin: 0;
    color: #333;
}

.publish-list {
    margin-bottom: 20px;
}

.empty-state {
    text-align: center;
    padding: 60px 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.empty-icon {
    font-size: 48px;
    margin-bottom: 16px;
}

.empty-state p {
    color: #666;
    margin-bottom: 20px;
    font-size: 16px;
}

.publish-item {
    display: flex;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin-bottom: 16px;
    padding: 20px;
    transition: box-shadow 0.3s ease;
}

.publish-item:hover {
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.item-image {
    width: 120px;
    height: 90px;
    margin-right: 20px;
    flex-shrink: 0;
}

.item-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #eee;
}

.item-content {
    flex: 1;
}

.item-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
}

.item-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    line-height: 1.4;
}

.status-badge {
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
}

.status-pending {
    background-color: #fff7e6;
    color: #fa8c16;
    border: 1px solid #ffd591;
}

.status-approved {
    background-color: #f6ffed;
    color: #52c41a;
    border: 1px solid #b7eb8f;
}

.status-rejected {
    background-color: #fff2f0;
    color: #ff4d4f;
    border: 1px solid #ffccc7;
}

.item-info {
    margin-bottom: 12px;
}

.company-name {
    font-size: 14px;
    color: #666;
    margin: 0 0 6px 0;
    font-weight: 500;
}

.item-desc {
    font-size: 14px;
    color: #888;
    margin: 0;
    line-height: 1.5;
}

.item-meta {
    display: flex;
    gap: 20px;
    margin-bottom: 12px;
    font-size: 13px;
    color: #666;
}

.item-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.publish-time {
    font-size: 13px;
    color: #999;
}

.item-actions {
    display: flex;
    gap: 8px;
}

.pagination {
    text-align: center;
    margin-top: 20px;
}

.detail-content {
    max-height: 500px;
    overflow-y: auto;
}

.detail-row {
    display: flex;
    margin-bottom: 16px;
    align-items: flex-start;
}

.detail-row label {
    width: 100px;
    font-weight: 600;
    color: #333;
    flex-shrink: 0;
}

.detail-row span {
    flex: 1;
    color: #666;
}

.detail-text {
    flex: 1;
    color: #666;
    line-height: 1.6;
    max-height: 120px;
    overflow-y: auto;
    padding: 8px;
    background-color: #f9f9f9;
    border-radius: 4px;
}

.reject-reason {
    color: #ff4d4f !important;
    font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .publish-history-container {
        padding: 10px;
    }
    
    .publish-item {
        flex-direction: column;
        padding: 15px;
    }
    
    .item-image {
        width: 100%;
        height: 180px;
        margin-right: 0;
        margin-bottom: 15px;
    }
    
    .item-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
    
    .item-footer {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
    
    .item-meta {
        flex-direction: column;
        gap: 5px;
    }
}
</style> 